import(/* webpackMode: "eager", webpackExports: ["GlobalBreadcrumb"] */ "/codebuild/output/src3883470271/src/treeunfe-website-nextjs/src/components/organisms/global-breadcrumb/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Posts"] */ "/codebuild/output/src3883470271/src/treeunfe-website-nextjs/src/components/pages/landing-page/blog/post/index.tsx");
